import React from 'react';
import styles from './styles.css';
import { Email } from 'constants/email';
import { mail } from 'fluent-mailto';
import { Text } from 'Common/components/Atoms/Text';

const GenericErrorBody = () => {
  return (
    <div className={styles.container}>
      <Text variant="h1" color="textPrimary">
        Oops! It looks like something went wrong...
      </Text>
      <div className={styles.warning} />
      <Text>
        We&apos;re sorry! An error occurred and our team has been notified.
        <br /> please try again and email us at{' '}
        <a href={mail.to(Email.SUPPORT).build()} className={styles.email}>
          {Email.SUPPORT}
        </a>{' '}
        if you
        <br /> continue having trouble.
      </Text>
    </div>
  );
};

export default GenericErrorBody;
